export default __webpack_public_path__ + "media/images/preview-706b80220c90b6a649a95b9327571c0c.png";